import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Carousel } from "@vds/carousels";
import {
  TitleLockup,
  TitleLockupSubtitle,
  TitleLockupTitle
} from "@vds/core";
import { PlanTile } from "@vbg-ds/core";
import { MarginSpacerM, MarginSpacerL } from "common/components/styleTag";
import { useMediaQuery } from "react-responsive";
import { Icon } from "@vds/icons";
import { Text } from '@vds/core';

const PlansOverview = ({}) => {
  const isMobile = useMediaQuery({
    query: "(max-width:767px)",
  });
  const { t } = useTranslation(["byod"]);
  const aemContentMonarch = t("byodMonarch", {
    ns: "byod",
    returnObjects: true,
  });
  const [planQty, setPlanQty] = useState(1);
  const bulletDetails = (planData) => {
    return planData.details.map((item, index) => {
      return (
        <>
          <MarginSpacerM />
          <div
            key={index}
            style={{ display: "flex", alignItems: "start", gap: "8px" }}
          >
            <Icon name="checkmark" size="small" color="#E10014"></Icon>
            <Text kind="body" size="small">{item.title}</Text>
          </div>
        </>
      );
    });
  };
  const planDetails = (planData) => {
    const component = (
      <PlanTile
        blocks={[
          {
            badge: {
              backgroundColor: "black",
              children: planData.badgeText || "test",
            },
            height: "auto",
            kind: "header",
            paddingBottom: "12px",
            paddingTop: "12px",
            sidePadding: "16px",
            subtitle: {
              bold: true,
              children: planData.subTitle,
            },
            title: {
              children: planData.title || "test",
              color: "var(--vds-color-element-brandhighlight-onlightprimary)",
              size: "large",
            },
          },
          {
            height: "auto",
            kind: "price",
            paddingBottom: "12px",
            paddingTop: "12px",
            prices: [
              {
                size:"medium",
                helperText: {
                  leadingText: planData.priceText,
                },               
                info: planData.isMyBiz && {
                  children:
                    planQty == 2
                      ? planData.autopayPrice2
                      : planQty == 3
                      ? planData.autopayPrice3
                      : planQty == 4
                      ? planData.autopayPrice4
                      : planQty == 5
                      ? planData.autopayPrice5
                      : planData.autopayPrice1,
                },
                orientation: "horizontal",
                price: {
                  children: planData.isMyBiz
                    ? planQty == 2
                      ? planData.price2
                      : planQty == 3
                      ? planData.price3
                      : planQty == 4
                      ? planData.price4
                      : planQty == 5
                      ? planData.price5
                      : planData.price1
                    : planData.price,
                },
              },
            ],
            sidePadding: "16px",
          },
          planData.isMyBiz == true && {
                  actions: [
                    {
                      controlWidth: "100%",
                      kind: "stepper",
                      minValue: "1",
                      maxValue: "5",
                      defaultValue: "1",
                      onChange: (val) => setPlanQty(val),
                      trailingText: planQty > 1 ? " lines" :" line"
                    },
                  ],
                  height: "auto",
                  kind: "action",
                  paddingBottom: "12px",
                  paddingTop: "12px",
                  sidePadding: "24px",
                },
          {
            children: <>{bulletDetails(planData)}</>,
            paddingBottom: "12px",
            paddingTop: "12px",
            sidePadding: "24px",
            height: "auto",
            marginTop: "12px !important",
          },
          //empty child
          {
            children: "",
            kind: "custom",
            paddingBottom: "12px",
            paddingTop: "12px",
            sidePadding: "16px",
          },
        ]}
        disableAnimation
        height="540px"
        surface="lightPrimary"
        width="290px"
      />
    );
    return component;
  };
  return (
    <PlanOverviewContainer>
      <TitleLockup>
        <TitleLockupTitle
          size={isMobile ? "titleLarge" : "titleXLarge"}
          bold={false}
          color="#E10014"
        >
          {aemContentMonarch?.plansOverview?.title}
        </TitleLockupTitle>
        <TitleLockupSubtitle
          size={isMobile ? "titleXSmall" : "titleSmall"}
          bold={false}
        >
          {aemContentMonarch?.plansOverview?.subTitle}
        </TitleLockupSubtitle>
      </TitleLockup>
      <MarginSpacerM />
      <PlanTileContainer>
        <Carousel
          layout={isMobile ? "1UP" : "2UP"}
          peek={isMobile ? "peek" : "standard"}
          showArrows={true}
          aspectRatio="1:1"
          gutter={isMobile ? "12px" : "24px"}
          surface="light"
          paginationFill="light"
          paginationDisplay="persistent"
          paginationInset="12px"
          data={Object.values(aemContentMonarch?.plansOverview?.plans)}
          renderItem={(props) => {
            return planDetails(props);
          }}
        />
      </PlanTileContainer>
      <MarginSpacerL/>
      <Text kind="micro" color='#716F6D'><span dangerouslySetInnerHTML={{ __html: aemContentMonarch?.plansOverview?.disclaimer}}></span></Text>
    </PlanOverviewContainer>
  );
};

const PlanOverviewContainer = styled.div`
  width: 100%;
`;

const PlanTileContainer = styled.div`
  width: 100%; 
  overflow-x: auto; 
  overflow-y: hidden;
  padding: 0; 
  margin: 0; 
  @media (max-width: 767px)  {
  [class^="SlotContainer-VDS"] {
      padding-right:32px;
    }
}
     [class^="OuterTileContainer-VDS"] {
      padding: 0px !important;
      background-color: transparent !important;
    }
    [class^="CarouselContainer-VDS"] {
      padding-left: 0px !important;
      width: 100%;
    }
    [class^="SlotContainer-VDS"] {
      flex: 0 0 290px !important;
    }
  .slotContainer:first-child {
    padding-left: 0px;
  }
`;
export default PlansOverview;
